/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { useFiltersHeightStore } from "@/stores/useFiltersHeightStore";
import { useMainBannerStore } from "@/stores/useMainBannerStore";
import { useTableStoreByRoute } from "@/stores/useTableStore";

import { colors } from "@dotnet/telematics-design-system";

import { ROUTES, useMediaQueries } from "../../../../shared";
import useGeneralHeights from "../../../../shared/hooks/useGeneralHeights";
import { useTableStyles } from "../../styles/styles";
import NoInitialResults from "./NoInitialResults";
import NoResultsFound from "./NoResultsFound/NoResultsFound";

interface ITableEmptyProps {
  route: ROUTES;
  hasSearch: boolean;
}

const TableEmpty = ({ route, hasSearch }: ITableEmptyProps) => {
  const { toMd, toLg, toSm } = useMediaQueries();

  const {
    params: { contains, filters }
  } = useTableStoreByRoute(route);

  const mainBannerHeight = useMainBannerStore(state => state.height);
  const filtersHeightValue = useFiltersHeightStore(state => state.height);

  const {
    DESKTOP_TABLE_FOOTER_HEIGHT,
    EMPTY_TABLE_HEADER_HEIGHT,
    NAVBAR_HEIGHT,
    TABLE_TOOLBAR_HEIGHT,
    XSM_PAGE_HEADER_HEIGHT
  } = useGeneralHeights(mainBannerHeight);

  const { emptyTable, emptyTableInnerDiv } = useTableStyles();

  const calculateMobileViewHeight = () => {
    return `calc(100vh - ${XSM_PAGE_HEADER_HEIGHT} - ${NAVBAR_HEIGHT} - ${TABLE_TOOLBAR_HEIGHT(
      toMd,
      hasSearch,
      undefined,
      filtersHeightValue
    )} - ${EMPTY_TABLE_HEADER_HEIGHT} - ${DESKTOP_TABLE_FOOTER_HEIGHT(toLg)})`;
  };
  const noResults = contains ?? filters;

  return (
    <div className="remaining-height" data-testid="empty-table">
      <div css={css(emptyTable)}>
        <div
          css={css({
            height: EMPTY_TABLE_HEADER_HEIGHT,
            boxSizing: "border-box",
            background: colors.blue100,
            borderTop: `1px solid ${colors.blue200}`,
            borderBottom: `1px solid ${colors.blue200}`
          })}
        />

        <div
          css={css([
            emptyTableInnerDiv,
            {
              height: toSm ? calculateMobileViewHeight() : "unset",
              padding: toSm ? "0" : "unset"
            }
          ])}
        >
          {/* error case should be handled in the future */}
          {noResults ? (
            <NoResultsFound route={route} />
          ) : (
            <NoInitialResults route={route} />
          )}
        </div>
      </div>
    </div>
  );
};

export default TableEmpty;
